import { ICellRendererParams } from '@ag-grid-community/core'
import { Checkbox } from 'components/common'

type Props = {
  isEditor: boolean
  params: ICellRendererParams
  options: any[]
}

const AggregatorsCellRenderer = ({ isEditor, params, options }: Props) => {
  const onChange = (option: any) => {
    if (!isEditor) return

    const updatedAggregators = params.value?.some(
      (agg: any) => agg?._id === option?._id,
    )
      ? params.value?.filter((agg: any) => agg?._id !== option?._id)
      : [...params.value, option]

    const rowNode = params.api.getRowNode(params.data?._id)
    rowNode?.setDataValue('aggregators', updatedAggregators)
  }

  if (!isEditor) {
    return (
      <div className="flex h-full w-full max-w-3xl flex-wrap gap-3 py-4">
        {params.value.map((aggregator: any) => (
          <span
            className="min-w-[30%] rounded-md bg-slate-200/70 px-2 py-1 text-xs text-gray-800"
            key={`${aggregator?.aggregatorId}^${params.data?._id}`}
          >
            {aggregator?.aggregatorName}
          </span>
        ))}
      </div>
    )
  }

  return (
    <div className="flex h-full w-full max-w-2xl flex-wrap gap-3 py-4">
      {options.map((option: any) => {
        return (
          <div key={`${option._id}^${params.data._id}`} className="w-[48%]">
            <Checkbox
              col={2}
              label={option.aggregatorName}
              checked={params.value.some((agg: any) => agg._id === option._id)}
              // aggregator id ^ ftp config id
              name={`${option._id}^${params.data._id}`}
              value={`${option._id}^${params.data._id}`}
              onSelect={() => onChange(option)}
            />
          </div>
        )
      })}
    </div>
  )
}

export default AggregatorsCellRenderer
